import { Link } from "@mui/material";
import { Map, GeoJSON } from "leaflet";
import { useTranslation } from "react-i18next";

import {
  DrawType,
  MeasureImpact,
  MeasureConfLayer,
  MeasureConf,
  DrawState,
} from "types/types";
import DrawPolygon from "../DrawPolygon";

interface Props {
  mapRef: Map;
  selectedMeasure: MeasureImpact;
  measureConfigurations: MeasureConf[];
  basePolygon: GeoJSON;
  minArea: number;
  drawState: DrawState;
  updateDrawState: (drawType: DrawType) => void;
  addNewGeometryToMeasureConfig: (
    newLayer: MeasureConfLayer,
    updatedMeasureConfigs: MeasureConf[]
  ) => void;
}

export function AddNewPolygon(props: Props) {
  const {
    mapRef,
    selectedMeasure,
    measureConfigurations,
    basePolygon,
    minArea,
    drawState,
    updateDrawState,
    addNewGeometryToMeasureConfig,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      <DrawPolygon
        mapRef={mapRef}
        basePolygon={basePolygon}
        selectedMeasure={selectedMeasure}
        measureConfigurations={measureConfigurations}
        minArea={minArea}
        drawState={drawState}
        updateDrawState={updateDrawState}
        addNewGeometryToMeasureConfig={addNewGeometryToMeasureConfig}
      />
      <Link
        onClick={() => updateDrawState("create")}
        className={`${drawState.drawType === "edit" ? "disabled" : ""}`}
      >
        {t("label.addAPolygon")}
      </Link>
    </>
  );
}
